import { createContext, useContext } from 'react'

export type CameraContextType = {
  isCameraOpen: boolean
  cameraOpen: (fn: (photo: Blob) => Promise<void>) => void
  cameraClose: () => void
  setHelperText: (helperText: string | null) => void
}

export const CameraContext = createContext<CameraContextType>(
  {} as CameraContextType,
)

export const useCameraContext = () => useContext(CameraContext)
